import React from "react";
import Header from "../components/dashboard/header";
import Footer from "../components/footers/footer";
import { Outlet } from "react-router-dom";
export default function DefaultLayout() {
  return (
    <>
      <Header />{" "}
      <div className="default_class float-left w-full">
        {" "}
        <Outlet />
      </div>{" "}
      <Footer />
    </>
  );
}
